import { ApiEndpoints } from "../../utils/app-constants";
import { toCondensedDate } from "../../utils/date-utils";
import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../utilities/document-request";
import { API_METHODS } from "../utilities/type-models";

export class ProductionPaperworkOrderDocument implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab: boolean = false;
    public url: string = '';
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'GET';

    constructor(orderIds: string) {
        this.url = ApiEndpoints.REPORTS_PRODUCTION_ORDERS_PAPERWORK.formattify(orderIds);
        this.filename = `ProductionRun_Paperwork_${ toCondensedDate(new Date()) }`;
    }

}
